module.exports = __webpack_public_path__ + "img/IncredEvent-Logo-Dark.5b45932d.webp";